import { AppComponent } from '@official/app.component';
import { AppRoutingModule } from '@official/routes/app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '@official-env/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InterceptorOfficial } from '@shared/interceptors/interceptor-official';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoadingOverlayService } from '@ui-core/services/loading-overlay/loading-overlay.service';
import { LocalStorageManagementService } from '@shared/services/local-storage-management/local-storage-management.service';
import { LoginComponent } from '@official/pages/login/login.component';
import { MaterialModule } from '@ui-core/shared/material.module';
import { MenuService } from '@official/services/menu/menu.service';
import { NgModule } from '@angular/core';
import { NotFoundComponent } from '@official/pages/not-found/not-found.component';
import { SdkModule } from '@sdk/sdk.module';
import { UiCoreModule } from '@ui-core/ui-core.module';
import { UserManagementComponent } from '@official/pages/user-management/user-management.component';
import { LoginFormComponent } from '@official/pages/login/login-form/login-form.component';
import { LoginAuthService } from '@shared/services/login-auth/login-auth.service';
import { RolesManagementComponent } from '@official/pages/roles-management/roles-management.component';
import { ActionService } from '@shared/services/action-service/action.service';
import { ModalActionHandler } from '@shared/services/action-service/handlers/modal-action-handler';
import { MapActionHandler } from '@shared/services/action-service/handlers/map-action-handler';
import { PanelActionHandler } from '@shared/services/action-service/handlers/panel-action-handler';
import { RouterActionHandler } from '@shared/services/action-service/handlers/router-action-handler';
import { OAuthConfigModule } from '@official/config/oauth/oauth.module';
import { ManageAuditComponent } from './pages/manage-audit/manage-audit.component';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import {IMqttServiceOptions, MqttModule} from "ngx-mqtt";
import { SdkDynamicFiltersService } from "@sdk/services/sdk-dynamic-filters/sdk-dynamic-filters.service";

const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
  hostname  : environment.mqtt.hostname,
  port      : environment.mqtt.port,
  protocol  : (environment.mqtt.protocol === "wss") ? "wss" : "ws",
  path      : environment.mqtt.path,
  username  : environment.mqtt.username,
  password  : environment.mqtt.password,
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoginFormComponent,
    NotFoundComponent,
    UserManagementComponent,
    RolesManagementComponent,
    ManageAuditComponent,
  ],
  imports: [
    MqttModule.forRoot(MQTT_SERVICE_OPTIONS),
    OAuthConfigModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    MaterialModule,
    ReactiveFormsModule,
    SdkModule,
    UiCoreModule,
  ],
  providers: [
    LoginAuthService,
    LocalStorageManagementService,
    MenuService,
    ActionService,
    ModalActionHandler,
    MapActionHandler,
    PanelActionHandler,
    RouterActionHandler,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorOfficial,
      multi: true,
    },
    {
      provide: 'environment',
      useValue: environment,
    },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: {
        timeZone: 'Europe/Madrid'
      }
    },
    SdkDynamicFiltersService,
    LoadingOverlayService,
  ],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule { }
